import { Component, Inject, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BOXES_FIELD, COURSE_FIELD, DOCS_TO_TRANSFER_FIELD, DOCS_TO_TRANSFER_STEP, END_DATE_FIELD, FILES_FIELD, FILES_STEP, IN_CHARGE_FIELD, MAIN_DATA_STEP, ORDER_FIELD, PHONE_FIELD, RESPONSIBLE_FIELD, START_DATE_FIELD, SUPPORT_FIELD, UNIT_FIELD } from '../../../model/contants/udeu-transfer';
import { StepTypes } from '../../../model/enums/step-types';
import { UDeuStep } from '../../../model/classes/udeu-step';
import { MatFormFieldType } from '../../../model/enums/mat-form-field-types';
import { UdeuService } from '../../../services/udeu.service';
import { Store } from '@ngrx/store';
import { AppStore, getUserProfile, SnackbarErrorAction, SnackbarWarningAction } from '@alfresco/aca-shared/store';
import { DateType } from 'projects/alden-extension/src/lib/models/date-types';
import { SMTDL_OPTION_ITEM_NODE_TYPE, SUPPORT_DATALIST_NAME, SUPPORT_KEY, TRANSFER_ORDER_DATALIST_NAME } from '../../../model/contants/datalists';
import { Empleado } from '../../../model/classes/gaude-empleado';
import { SMTDataListsService } from 'projects/alden-extension/src/lib/services/data-lists.service';
import { KeyValue } from '@angular/common';
import { GROUP_TRANSFERS_SITE_MANAGER, UDEU_TRANSFER_ACCEPTED_STATUS, UDEU_TRANSFER_CATALOGED_STATUS, UDEU_TRANSFER_DRAFT_STATUS, UDEU_TRANSFER_PENDING_STATUS, UDEU_TRANSFER_PHYSICAL_SUPPORT, UDEU_TRANSFER_REJECTED_STATUS, UDEU_TRANSFER_SENDED_STATUS } from '../../../model/contants/deusto';
import { ProfileState } from '@alfresco/adf-extensions';
import { Observable } from 'rxjs';
import { isInGroup } from 'projects/alden-extension/src/lib/rules/alden.rules';
import { take } from 'rxjs/operators';
import { UdeuCreateTransfer, UdeuData, UdeuDocument, UdeuTransfer } from '../../../model/classes/udeu-transfer';
import { TransferActionTypes } from '../../../store/actions/transfer-actions';
import { ArrayValidators } from 'projects/alden-extension/src/lib/validators/array.validator';
import { TransferService } from '../../../services/transfer.service';
import { ReloadCustomListTableAction } from 'projects/alden-extension/src/lib/store/actions/alden.actions';
import { Router } from '@angular/router';
import { SMTConfirmDialogComponent } from 'projects/alden-extension/src/lib/dialogs/confirm/confirm.dialog';
import { AttachedFile } from 'projects/alden-extension/src/lib/models/attached-file';
import { UdeuStatus } from '../../../model/classes/udeu-status';
import { MatStep } from '@angular/material/stepper';
import { UdeuCreateFile, UdeuFile } from '../../../model/classes/udeu-files';
import { SMTLoadingDialogComponent } from 'projects/alden-extension/src/lib/dialogs/loading/loading.dialog';
import { APP_CONFIG_FILE_SIZE_LIMIT } from 'projects/alden-extension/src/lib/models/alden-constants';
import { AldenService } from 'projects/alden-extension/src/lib/services/alden.service';

export interface DialogData {
  transferActionType: TransferActionTypes;
  UUID: string;
  openedByUrl?: boolean;
}

@Component({
  templateUrl: './create-transfer.dialog.html',
  styleUrls: ['./create-transfer.dialog.scss'],
})
export class CreateTransferDialogComponent implements OnInit {
  loading: boolean;

  private _formBuilder = inject(FormBuilder);
  steps: { [id: string]: UDeuStep };

  mainFormGroup: FormGroup<any>;
  dataFormGroup: FormGroup<any>;
  docsToTransferFormGroup: FormGroup<any>;
  filesFormGroup: FormGroup<any>;

  StepTypes: typeof StepTypes = StepTypes;
  MatFormFieldType: typeof MatFormFieldType = MatFormFieldType;
  DateType: typeof DateType = DateType;
  TransferActionTypes: typeof TransferActionTypes = TransferActionTypes;

  profile$: Observable<ProfileState>;
  isManager: boolean;
  canEditExtraProps: boolean;
  UDEU_TRANSFER_REJECTED_STATUS = UDEU_TRANSFER_REJECTED_STATUS;
  UDEU_TRANSFER_ACCEPTED_STATUS = UDEU_TRANSFER_ACCEPTED_STATUS;
  UDEU_TRANSFER_CATALOGED_STATUS = UDEU_TRANSFER_CATALOGED_STATUS;

  udeuTransfer: UdeuTransfer;

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData, private dialogRef: MatDialogRef<CreateTransferDialogComponent>, private dialog: MatDialog, 
  public udeuService: UdeuService, private smtDataListsService: SMTDataListsService, protected store: Store<AppStore>, private transferService: TransferService, 
  private router: Router, private aldenService: AldenService) {
    this.profile$ = this.store.select(getUserProfile);
  }

  async ngOnInit(): Promise<void> {
    this.loading = true;
    this.beforeClosed();
    
    await this.initilizeForms();
    this.createSteps();

    const promises = this.data?.transferActionType !== TransferActionTypes.ViewTransfer ? [
      // MAIN_DATA_STEP
      this.udeuService.getMasterList(this.steps, MAIN_DATA_STEP, SUPPORT_FIELD, SUPPORT_DATALIST_NAME),
      this.udeuService.getMasterList(this.steps, MAIN_DATA_STEP, ORDER_FIELD, TRANSFER_ORDER_DATALIST_NAME)
    ] : [];

    let setDefaultSupportValue = false;
    if(this.data?.transferActionType !== TransferActionTypes.ViewTransfer) {
      setDefaultSupportValue = !this.dataFormGroup.get(SUPPORT_FIELD).value;
      if(setDefaultSupportValue) {
        promises.push(this.smtDataListsService.getValueOfKey(SUPPORT_KEY, SMTDL_OPTION_ITEM_NODE_TYPE));
      }
    }

    await Promise.all(promises).then((res: any[][]) => {
      if(setDefaultSupportValue) {
        const supportForm =  this.steps[MAIN_DATA_STEP].form;
        const support = supportForm.fields[SUPPORT_FIELD].options.find((opt) => opt.key === res[promises.length-1][0]?.value);
        supportForm.group.get(SUPPORT_FIELD).setValue(support);
        this.supportChanged(support);
      }
    }).catch((err) => { 
      console.error("ERROR", err);
      this.store.dispatch(new SnackbarErrorAction('ALDEN.MESSAGES.ERRORS.RESPONSE.500'));
      this.dialogRef.close();
    });

    this.profile$.pipe(
      take(1)
    ).subscribe((profile) => {
      this.isManager = isInGroup(profile, GROUP_TRANSFERS_SITE_MANAGER);
      this.canEditExtraProps = this.isManager && this.data?.transferActionType === TransferActionTypes.CatalogTransfer
      this.loading = false;
    });
  }

  checkOpenEditionByUrl() {
    if(this.data?.openedByUrl) {
      const status = this.udeuTransfer?.status?.status as KeyValue<string, string>;
      if(this.isManager) {
        switch (status.key) {
          case UDEU_TRANSFER_SENDED_STATUS:
            this.data.transferActionType = TransferActionTypes.ValidateTransfer;
            break;
          case UDEU_TRANSFER_ACCEPTED_STATUS:
            this.data.transferActionType = TransferActionTypes.CatalogTransfer;
            break;
          default:
            this.data.transferActionType = TransferActionTypes.ViewTransfer;
            this.mainFormGroup.disable();
            break;
        }
      } else {
        switch (status.key) {
          case UDEU_TRANSFER_PENDING_STATUS:
          case UDEU_TRANSFER_DRAFT_STATUS:
          case UDEU_TRANSFER_REJECTED_STATUS:
            this.data.transferActionType = TransferActionTypes.EditTransfer;
            break;
          default:
            this.data.transferActionType = TransferActionTypes.ViewTransfer;
            this.mainFormGroup.disable();
            break;
        }
      }
    }
  }

  beforeClosed() {
    // Interceptamos el evento de cerrar el diálogo
    this.dialogRef.backdropClick().subscribe(() => {
      this.closeDialog();
    });

    // Interceptamos el evento de presionar la tecla Esc
    this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === "Escape") {
        this.closeDialog();
      }
    });
  }

  closeDialog() {
    const dialogRef = this.dialog.open(SMTConfirmDialogComponent, {
      data: {
        title: 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.CLOSE.DIALOG.TITLE',
        message: 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.CLOSE.DIALOG.MESSAGE',
        noLabel: 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.CLOSE.DIALOG.NO_LABEL',
        yesLabel: 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.CLOSE.DIALOG.YES_LABEL'
      },
      minWidth: '250px'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {       
        this.dialogRef.close();
      }
    });
  }

  async initilizeForms() {
    const UUID = this.data?.UUID;
    if(UUID) {
      await this.transferService.getTransfer(UUID).then((res) => { 
        this.udeuTransfer = res;
      });
    } else {
        await this.udeuService.getEmployeeData().then((res: KeyValue<string, Empleado>) => { 
          if(res) {
            this.udeuTransfer = new UdeuTransfer();
            const data = new UdeuData();
            data.unit = res.value?.unidad;
            data.inCharge = res.value?.nombre;
            this.udeuTransfer.data = data;
          }
        }).catch((err) => { 
          console.error("ERROR", err);
          this.store.dispatch(new SnackbarErrorAction('ALDEN.MESSAGES.ERRORS.RESPONSE.500'));
          this.dialogRef.close();
        });
    }

    this.dataFormGroup = this._formBuilder.group({
      [SUPPORT_FIELD]: [this.udeuTransfer?.data?.support, [Validators.required]],
      [COURSE_FIELD]: [this.udeuTransfer?.data?.course, [Validators.required]],
      [UNIT_FIELD]: [this.udeuTransfer?.data?.unit, [Validators.required]],
      [BOXES_FIELD]: [this.udeuTransfer?.data?.boxes],
      [RESPONSIBLE_FIELD]: [this.udeuTransfer?.data?.responsible, [Validators.required]],
      [IN_CHARGE_FIELD]: [this.udeuTransfer?.data?.inCharge, [Validators.required]],
      [PHONE_FIELD]: [this.udeuTransfer?.data?.phone, [Validators.required]],
      [ORDER_FIELD]: [this.udeuTransfer?.data?.order],
      [START_DATE_FIELD]: [this.udeuTransfer?.data?.startDate],
      [END_DATE_FIELD]: [this.udeuTransfer?.data?.endDate],
    });

    this.docsToTransferFormGroup = this._formBuilder.group({
      [DOCS_TO_TRANSFER_FIELD]: this._formBuilder.array([], ArrayValidators.required)
    });

    this.filesFormGroup = this._formBuilder.group({
      [FILES_FIELD]: [],
    });

    this.mainFormGroup = this._formBuilder.group({
      data: this.dataFormGroup,
      docsToTransfer: this.docsToTransferFormGroup,
      files: this.filesFormGroup
    });

    this.checkOpenEditionByUrl();

    if(!UUID && this.dataFormGroup.get(UNIT_FIELD).value)
      this.dataFormGroup.get(UNIT_FIELD).disable();
    if(!UUID && this.dataFormGroup.get(IN_CHARGE_FIELD).value)
      this.dataFormGroup.get(IN_CHARGE_FIELD).disable();

    if(this.data?.transferActionType === TransferActionTypes.ViewTransfer 
      || this.data?.transferActionType === TransferActionTypes.ValidateTransfer 
      || this.data?.transferActionType === TransferActionTypes.CatalogTransfer) {
      this.mainFormGroup.disable();
    }
  }

  createSteps() {
    this.steps = {
      [MAIN_DATA_STEP]: {
        name: "DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.STEPS.MAIN_DATA.TITLE",
        type: StepTypes.GENERIC,
        form: {
          group: this.dataFormGroup,
          fields: {
            [SUPPORT_FIELD]: {
              type: MatFormFieldType.SELECT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.MAIN_DATA.SUPPORT",
              changeFunc: [(option) => this.supportChanged(option)]
            },
            [COURSE_FIELD]: {
              type: MatFormFieldType.INPUT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.MAIN_DATA.COURSE"
            },
            [UNIT_FIELD]: {
              type: MatFormFieldType.INPUT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.MAIN_DATA.UNIT",
            },
            [BOXES_FIELD]: {
              type: MatFormFieldType.INPUT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.MAIN_DATA.BOXES"
            },
            [RESPONSIBLE_FIELD]: {
              type: MatFormFieldType.INPUT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.MAIN_DATA.RESPONSIBLE"
            },
            [IN_CHARGE_FIELD]: {
              type: MatFormFieldType.INPUT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.MAIN_DATA.IN_CHARGE",
            },
            [PHONE_FIELD]: {
              type: MatFormFieldType.INPUT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.MAIN_DATA.PHONE"
            },
            [ORDER_FIELD]: {
              type: MatFormFieldType.SELECT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.MAIN_DATA.ORDER"
            },
            [START_DATE_FIELD]: { 
              type: MatFormFieldType.DATE, label: "DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.MAIN_DATA.DATES", extraControlName: END_DATE_FIELD,
              placeholder: "DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.MAIN_DATA.START_DATE", extraPlaceholder: "DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.MAIN_DATA.END_DATE"
            },
          }
        }
      },
      [DOCS_TO_TRANSFER_STEP]: {
        name: "DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.STEPS.DOCS_TO_TRANSFER.TITLE",
        type: StepTypes.DOCS_TO_TRANSFER,
        form: {
          group: this.docsToTransferFormGroup,
        }
      },
      [FILES_STEP]: {
        name: "DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.STEPS.FILES.TITLE",
        type: StepTypes.FILES,
        form: {
          group: this.filesFormGroup
        }
      },
    }
  }

  supportChanged(option: KeyValue<string,string>) {
    if(option?.key === UDEU_TRANSFER_PHYSICAL_SUPPORT) {
      this.dataFormGroup.get(START_DATE_FIELD).addValidators(Validators.required);
      this.dataFormGroup.get(END_DATE_FIELD).addValidators(Validators.required);
      this.dataFormGroup.get(BOXES_FIELD).addValidators(Validators.required);
      this.dataFormGroup.get(ORDER_FIELD).addValidators(Validators.required);
    } else {
      this.dataFormGroup.get(START_DATE_FIELD).removeValidators(Validators.required);
      this.dataFormGroup.get(END_DATE_FIELD).removeValidators(Validators.required);
      this.dataFormGroup.get(BOXES_FIELD).removeValidators(Validators.required);
      this.dataFormGroup.get(ORDER_FIELD).removeValidators(Validators.required);
    }

    this.dataFormGroup.get(START_DATE_FIELD).updateValueAndValidity();
    this.dataFormGroup.get(END_DATE_FIELD).updateValueAndValidity();
    this.dataFormGroup.get(BOXES_FIELD).updateValueAndValidity();
    this.dataFormGroup.get(ORDER_FIELD).updateValueAndValidity();
  }

  createTransfer(save: boolean = false) {
    if(this.filesFormGroup.invalid && this.filesFormGroup.controls[FILES_FIELD].hasError('maxSize')) {
      const fileSizeLimit = this.aldenService.getAppConfigProp(APP_CONFIG_FILE_SIZE_LIMIT);
      this.store.dispatch(new SnackbarWarningAction('ALDEN.MESSAGES.ERRORS.FILE_SIZE_LIMIT', { fileSizeLimit }));
      return;
    }

    const udeuCreateTransfer = new UdeuCreateTransfer();
    const udeuTransfer = new UdeuTransfer();
    udeuTransfer.status = new UdeuStatus(save ? UDEU_TRANSFER_DRAFT_STATUS : UDEU_TRANSFER_SENDED_STATUS);

    udeuTransfer.data = this.createData();
    udeuTransfer.documents = this.createDocsToTransfer();
    udeuTransfer.files = this.createFiles(udeuCreateTransfer);
    
    udeuCreateTransfer.data = udeuTransfer;

    if(this.data.transferActionType === TransferActionTypes.CreateTransfer) {
      const dialogRef = this.dialog.open(SMTConfirmDialogComponent, {
            data: { 
              title: `DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.${ save ? 'SAVE' : 'SEND'}.DIALOG.TITLE`, 
              message: `DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.${ save ? 'SAVE' : 'SEND'}.DIALOG.MESSAGE`, 
              noLabel: `DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.${ save ? 'SAVE' : 'SEND'}.DIALOG.NO_LABEL`, 
              yesLabel: `DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.${ save ? 'SAVE' : 'SEND'}.DIALOG.YES_LABEL` },
            minWidth: '250px'
      });
      
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {      
          const loadingRef = this.dialog.open(SMTLoadingDialogComponent, {
            data: {
              title: 'Cargando...',
            },
            minWidth: '250px'
          });

          this.transferService.createTransfer(udeuCreateTransfer).then(() => {
            this.dialogRef.close();
            const route = '/viewer/transfers';
            this.router.url === route ? this.store.dispatch(new ReloadCustomListTableAction(false)) : this.router.navigate([route]);
          }).catch((err) => {
            console.error("ERROR", err);
            this.store.dispatch(new SnackbarErrorAction('Hubo un error inesperado. Contacte con el administrador.'));
          }).finally(() => {
            loadingRef.close();
          });
        }
      });
    } else if(this.data.transferActionType === TransferActionTypes.EditTransfer || this.data.transferActionType === TransferActionTypes.CatalogTransfer) {
      let title = `DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.${ save ? 'SAVE' : 'SEND'}.DIALOG.TITLE`;
      let message = `DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.${ save ? 'SAVE' : 'SEND'}.DIALOG.MESSAGE`;
      let noLabel = `DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.${ save ? 'SAVE' : 'SEND'}.DIALOG.NO_LABEL`;
      let yesLabel = `DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.${ save ? 'SAVE' : 'SEND'}.DIALOG.YES_LABEL`;
      let formField = false;

      if(this.data.transferActionType === TransferActionTypes.CatalogTransfer) {
        udeuTransfer.status = new UdeuStatus(UDEU_TRANSFER_CATALOGED_STATUS);
        title = 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.CATALOG.DIALOG.TITLE';
        message = 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.CATALOG.DIALOG.MESSAGE';
        noLabel = 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.CATALOG.DIALOG.NO_LABEL';
        yesLabel = 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.CATALOG.DIALOG.YES_LABEL';
        formField = true;
      }

      const dialogRef = this.dialog.open(SMTConfirmDialogComponent, {
        data: { 
          title, 
          message, 
          noLabel, 
          yesLabel,
          formField,
        },
        minWidth: '250px'
      });
      
      dialogRef.afterClosed().subscribe((result) => {
        if (result) { 
          const loadingRef = this.dialog.open(SMTLoadingDialogComponent, {
            data: {
              title: 'Cargando...',
            },
            minWidth: '250px'
          });

          udeuCreateTransfer.data.status.observations = this.data.transferActionType === TransferActionTypes.CatalogTransfer ? result : "";

          this.transferService.updateTransfer(this.data.UUID, udeuCreateTransfer).then(() => {
            this.dialogRef.close();
            const route = '/viewer/transfers';
            this.router.url === route ? this.store.dispatch(new ReloadCustomListTableAction(false)) : this.router.navigate([route]);
          }).catch((err) => {
            console.error("ERROR", err);
            this.store.dispatch(new SnackbarErrorAction('Hubo un error inesperado. Contacte con el administrador.'));
          }).finally(() => {
            loadingRef.close();
          });
        }
      });
    }
  }

  createData(): UdeuData {
    const data = new UdeuData();
    data.support = (this.dataFormGroup.get(SUPPORT_FIELD).value as KeyValue<string,string>)?.key;
    data.course = this.dataFormGroup.get(COURSE_FIELD).value;
    data.unit = this.dataFormGroup.get(UNIT_FIELD).value;
    data.boxes = this.dataFormGroup.get(BOXES_FIELD).value;
    data.responsible = this.dataFormGroup.get(RESPONSIBLE_FIELD).value;
    data.inCharge = this.dataFormGroup.get(IN_CHARGE_FIELD).value;
    data.phone = this.dataFormGroup.get(PHONE_FIELD).value;
    data.order = (this.dataFormGroup.get(ORDER_FIELD).value as KeyValue<string,string>)?.key;
    data.startDate = this.dataFormGroup.get(START_DATE_FIELD).value;
    data.endDate = this.dataFormGroup.get(END_DATE_FIELD).value;
    return data;
  }
  
  createDocsToTransfer(): UdeuDocument[] {
    const value = (this.docsToTransferFormGroup.get(DOCS_TO_TRANSFER_FIELD).getRawValue() as UdeuDocument[]);
    return value?.length > 0 ? value : [];
  }

  createFiles(udeuCreateTransfer: UdeuCreateTransfer): UdeuFile[] {
    const value = (this.filesFormGroup.get(FILES_FIELD).getRawValue() as AttachedFile[]);
    if(value?.length > 0) {
      udeuCreateTransfer.files = [];
      return value.map((file) => {
        if(!file.uuid) {
          const udeuCreateFile: UdeuCreateFile = { id: file.fileId, file: file.file };
          udeuCreateTransfer.files.push(udeuCreateFile);
        }

        const udeuFile = new UdeuFile(file.uuid, file.fileId, file.name, '', file.description);
        return udeuFile;
      });
    }
    return [];
  }

  changeStatusTransfer(status: string) {
    // Aceptar transferencia
    let title = 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.ACCEPT.DIALOG.TITLE';
    let message = 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.ACCEPT.DIALOG.MESSAGE';
    let noLabel = 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.ACCEPT.DIALOG.NO_LABEL';
    let yesLabel = 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.ACCEPT.DIALOG.YES_LABEL';

    if(UDEU_TRANSFER_REJECTED_STATUS === status) {
      // Rechazar transferencia
      title = 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.REJECT.DIALOG.TITLE';
      message = 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.REJECT.DIALOG.MESSAGE';
      noLabel = 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.REJECT.DIALOG.NO_LABEL';
      yesLabel = 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.REJECT.DIALOG.YES_LABEL';
    }

    const dialogRef = this.dialog.open(SMTConfirmDialogComponent, {
      data: { 
        title,
        message, 
        noLabel, 
        yesLabel,
        formField: true,
      },
      minWidth: '250px'
    });
    
    dialogRef.afterClosed().subscribe((result) => {
      if (result !== false) {      
        const udeuStatus = new UdeuStatus(status, result);
        this.udeuService.updateStatus(this.data.UUID, udeuStatus).then(() => {
          this.dialogRef.close();
          const route = '/viewer/transfers';
          this.router.url === route ? this.store.dispatch(new ReloadCustomListTableAction(false)) : this.router.navigate([route]);
        })
        .catch((err) => {
          console.error("ERROR", err);
          this.store.dispatch(new SnackbarErrorAction('Hubo un error inesperado. Contacte con el administrador.'));
        });
      }
    });
  }

  isCompleted(matStep: MatStep) {
    const transferActionType = this.data?.transferActionType ?? TransferActionTypes.CreateTransfer;
    switch (transferActionType) {
      case TransferActionTypes.CreateTransfer:
        return !matStep.stepControl.invalid && matStep.interacted;

      case TransferActionTypes.EditTransfer:
      case TransferActionTypes.CatalogTransfer:
        return !matStep.stepControl.invalid;
    
      default:
        return false;
    }
  }

}
